import 'svelte/internal/disclose-version';
import * as $ from 'svelte/internal/client';
import { cn } from "$lib/utils.js";

var root = $.from_html(`<p><!></p>`);

export default function Card_description($$anchor, $$props) {
	$.push($$props, true);

	let ref = $.prop($$props, 'ref', 15, null),
		restProps = $.rest_props($$props, [
			'$$slots',
			'$$events',
			'$$legacy',
			'ref',
			'class',
			'children'
		]);

	var p = root();

	$.attribute_effect(p, ($0) => ({ 'data-slot': 'card-description', class: $0, ...restProps }), [() => cn("text-muted-foreground text-sm", $$props.class)]);

	var node = $.child(p);

	$.snippet(node, () => $$props.children ?? $.noop);
	$.reset(p);
	$.bind_this(p, ($$value) => ref($$value), () => ref());
	$.append($$anchor, p);
	$.pop();
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6W10sInNvdXJjZXMiOlsiY2FyZC1kZXNjcmlwdGlvbi5zdmVsdGUiXSwic291cmNlc0NvbnRlbnQiOlsiPHNjcmlwdCBsYW5nPVwidHNcIj5cblx0aW1wb3J0IHR5cGUgeyBIVE1MQXR0cmlidXRlcyB9IGZyb20gXCJzdmVsdGUvZWxlbWVudHNcIjtcblx0aW1wb3J0IHsgY24sIHR5cGUgV2l0aEVsZW1lbnRSZWYgfSBmcm9tIFwiJGxpYi91dGlscy5qc1wiO1xuXG5cdGxldCB7XG5cdFx0cmVmID0gJGJpbmRhYmxlKG51bGwpLFxuXHRcdGNsYXNzOiBjbGFzc05hbWUsXG5cdFx0Y2hpbGRyZW4sXG5cdFx0Li4ucmVzdFByb3BzXG5cdH06IFdpdGhFbGVtZW50UmVmPEhUTUxBdHRyaWJ1dGVzPEhUTUxQYXJhZ3JhcGhFbGVtZW50Pj4gPSAkcHJvcHMoKTtcbjwvc2NyaXB0PlxuXG48cFxuXHRiaW5kOnRoaXM9e3JlZn1cblx0ZGF0YS1zbG90PVwiY2FyZC1kZXNjcmlwdGlvblwiXG5cdGNsYXNzPXtjbihcInRleHQtbXV0ZWQtZm9yZWdyb3VuZCB0ZXh0LXNtXCIsIGNsYXNzTmFtZSl9XG5cdHsuLi5yZXN0UHJvcHN9XG4+XG5cdHtAcmVuZGVyIGNoaWxkcmVuPy4oKX1cbjwvcD5cbiJdLCJtYXBwaW5ncyI6Ijs7U0FFVSxFQUFFLFFBQTZCLGVBQWU7Ozs7NERBRnhELENBQUM7OztLQUtDLEdBQUcsOEJBQWEsSUFBSTtFQUdqQixTQUFTOzs7Ozs7Ozs7OztpRkFRVCxTQUFTLFlBRE4sRUFBRSxDQUFDLCtCQUErQjs7Ozs7OzZCQUY5QixHQUFHLGlCQUFILEdBQUc7OztBQUhoQixDQUFDIn0=